import { InjectionToken } from '@angular/core';

export const ORG_ID = new InjectionToken<string>('ORG_ID');
